import script from "./HeaderPaciente.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPaciente.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPaciente.vue?vue&type=style&index=0&id=123600f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123600f3"]])

export default __exports__